import React from 'react'
import { Box, Checkbox, Flex, Tooltip } from '@workwhile/ui'
import { useBillRatesContextValue } from '../context/BillRatesProvider'
import { CompanyPicker } from './CompanyPicker'
import { PositionPicker } from './PositionPicker'

const SHOW_DELETED_DISABLED_TOOLTIP = 'Select a company first'

export const BillRatesFilters = () => {
  const {
    state: { companyId, positionId, includeDeleted },
    actions: { setCompanyId, setPositionId, setIncludeDeleted },
  } = useBillRatesContextValue()

  const isShowDeletedDisabled = companyId === null

  const showDeletedCheckbox = (
    <Checkbox
      value={includeDeleted}
      disabled={isShowDeletedDisabled}
      onChange={(checked) => {
        if (companyId === null) {
          return
        }
        setIncludeDeleted(Boolean(checked))
      }}
    >
      Show inactive
    </Checkbox>
  )

  return (
    <Flex
      gap={3}
      mb={3}
      flexDirection={['column', 'column', 'row']}
      alignItems={['stretch', 'stretch', 'center']}
      maxWidth={['100%', '100%', '100%', '50%']}
    >
      <Box flex={1} minWidth={0}>
        <CompanyPicker value={companyId} onChange={setCompanyId} />
      </Box>
      <Box flex={1} minWidth={0}>
        <PositionPicker
          value={positionId}
          onChange={setPositionId}
          companyId={companyId}
        />
      </Box>
      <Flex alignItems="center" flex="none">
        {isShowDeletedDisabled ? (
          <Tooltip content={SHOW_DELETED_DISABLED_TOOLTIP}>
            <Box>{showDeletedCheckbox}</Box>
          </Tooltip>
        ) : (
          showDeletedCheckbox
        )}
      </Flex>
    </Flex>
  )
}
